import { Moment } from 'moment-timezone';
import { ready } from '../../app/support/utils';
import Practitioner from '../../app/models/Practitioner';
import CalendarEvent from '../../app/models/CalendarEvent';
import { localizedRoute, moment } from '../../app/support/helpers';
import { renderAlternativeAvailabilities } from '../practitioner/calendar/AlternativeAppointments';

ready(() => {
    const promotees = Practitioner.new(window.doctori.promotees as []);

    const urls = promotees.map((alternative) => {
        const params = {
            id: alternative.id,
            start: moment().format('YYYY-MM-DDTHH:mm:ss'),
            end: moment().add(3, 'day').format('YYYY-MM-DD'),
        }
        return localizedRoute('frontend.practitioners.availabilities', params)
    });

    const awaitJson = (responses) => Promise.all(responses.map((response) => {
        if (response.ok) return response.json();
        throw new Error(response.statusText);
    }));

    Promise.all(urls.map((url) => fetch(url)))
        .then(awaitJson)
        .then((data) => {
            data.forEach((availabilities, index) => {
                const practitioner   = promotees[index];
                const calendarEvents = CalendarEvent.new(availabilities as []);
                const calendar       = renderAlternativeAvailabilities(calendarEvents, generateThreeDaysTimePeriod());
                document.querySelector(`.calendarWrapper[data-id="${practitioner.id}"]`).innerHTML = calendar;
            });
        })
        .catch((error) => console.log("Error ", error));


    function generateThreeDaysTimePeriod(calendarEvent?: CalendarEvent): Moment[] {
        const {start, end} = threeDaysInterval(calendarEvent);
        // @ts-ignore
        const range = moment().range(start, end);
        return Array.from(range.by('days', { excludeEnd: true })) as Moment[];
    }

    function threeDaysInterval(calendarEvent?: CalendarEvent): {start: string, end: string} {
        const start = moment(calendarEvent?.start).format('YYYY-MM-DD');
        const end   = moment(calendarEvent?.start).add(3, 'day').format('YYYY-MM-DD');
        return {start, end};
    }
});
